export enum ReferenceItemFormAccessor {
  ItemId = 'itemId',
  Qty = 'qty',
  SubLines = 'subLines',
}
